module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/4/5-92fa6778ce4e854f342bcdba8e621f18.jpg";